import { Award, Compass, ShieldCheck, Users } from 'lucide-react';
import PageHero from '../components/PageHero';
import CTASection from '../components/CTASection';

const values = [
  { icon: Compass, title: 'Independent', body: 'We are not tied to a single bank or product. We work for your business outcomes.' },
  { icon: ShieldCheck, title: 'Trustworthy', body: 'Straightforward terms, no hidden fees, and disciplined underwriting on every deal.' },
  { icon: Users, title: 'Relationship-led', body: 'A dedicated advisor stays with you across the life of every facility we provide.' },
  { icon: Award, title: 'Industry-savvy', body: 'Specialist underwriting across construction, transport, manufacturing and beyond.' },
];

export default function About() {
  return (
    <>
      <PageHero
        eyebrow="About Us"
        title="An independent finance partner for Canadian business"
        subtitle="Foxstone Funding provides equipment financing and working capital solutions to businesses across the country."
        image="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=1920&q=80"
      />

      <section className="py-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 grid lg:grid-cols-2 gap-14 items-center">
          <div className="relative">
            <div className="absolute -top-6 -left-6 w-32 h-32 border-4 border-fx-gold rounded-md hidden lg:block" />
            <img src="https://images.unsplash.com/photo-1557804506-669a67965ba0?w=1200&q=80" alt="Foxstone team" className="relative rounded-lg shadow-xl w-full h-[460px] object-cover" />
          </div>
          <div>
            <p className="text-xs uppercase tracking-[0.28em] text-fx-gold font-semibold">Our Story</p>
            <h2 className="font-display text-4xl text-fx-navy font-bold mt-3">Disciplined growth, built on relationships</h2>
            <div className="fx-section-divider mt-5" />
            <p className="mt-6 text-slate-700 leading-relaxed">
              Foxstone Funding was built on a single conviction: business owners deserve a finance partner who can move at the speed of opportunity. We help Canadian businesses acquire the equipment and working capital they need to grow.
            </p>
            <p className="mt-4 text-slate-700 leading-relaxed">
              Our independence is our advantage. Without rigid bank covenants, we structure facilities the way they need to be structured — around your industry, your seasonality and your ambition.
            </p>
          </div>
        </div>
      </section>

      <section className="py-20 bg-fx-cream">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="text-center max-w-2xl mx-auto">
            <p className="text-xs uppercase tracking-[0.28em] text-fx-gold font-semibold">What we stand for</p>
            <h2 className="font-display text-4xl text-fx-navy font-bold mt-3">Our values</h2>
            <div className="fx-section-divider mx-auto mt-5" />
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5 mt-12">
            {values.map((v, i) => (
              <div key={i} className="bg-white p-7 rounded-lg border border-slate-100 fx-lift">
                <div className="w-12 h-12 rounded-md bg-fx-navy text-fx-gold flex items-center justify-center"><v.icon className="w-6 h-6" /></div>
                <h3 className="font-display text-xl text-fx-navy font-bold mt-5">{v.title}</h3>
                <p className="mt-3 text-sm text-slate-600 leading-relaxed">{v.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CTASection />
    </>
  );
}
